<template>
    <FilterLayout :advanceOption="false">
        <PersonInfoSection 
            class="mt-2"
            :national_id="filterState.national_id"
            :full_name="filterState.full_name"
            @update:national_id="handelNationalIdChange"
            @update:full_name="handelFullNameChange"/>
        <div class="flex justify-end mt-3">
            <button class="btn btn-outline-secondary mr-2" @click="resetState">
                ล้าง
            </button>
            <button class="btn btn-primary" @click="sendToStore">
                ค้นหา
            </button>
        </div>
    </FilterLayout>
</template>
<script setup>
import FilterLayout from "./layout/index.vue"
import PersonInfoSection from "./component/PersonInfoSection.vue"
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";

const INIT_FILTER_VALUE = {
    national_id: null,
    full_name: null,
    advance_filter: false
};

const store = useStore();
const filterState = reactive({ ...INIT_FILTER_VALUE });

onMounted(() => {
  Object.assign(
    filterState,
    JSON.parse(JSON.stringify(store.getters["volunteerFilter/getAllFilter"]))
  );
});

const handelNationalIdChange = (evt) => {
  filterState.national_id = evt;
};
const handelFullNameChange = (evt) => {
  filterState.full_name = evt;
};

const resetState = () => {
  Object.assign(filterState, INIT_FILTER_VALUE);
  store.dispatch("volunteerFilter/clearStore");
};
const sendToStore = () => {
  store.dispatch("volunteerFilter/setStore", JSON.parse(JSON.stringify(filterState)));
};


</script>